import { Component, Input } from '@angular/core';

@Component({
    selector: 'new-kpi-item-placeholder',
    templateUrl: './new-kpi-item-placeholder.component.html',
    styleUrls: ['./new-kpi-item-placeholder.component.scss']
})
export class NewKpiItemPlaceholderComponent {
    @Input() titleTooltip: string;
    @Input() name: string;
    @Input() isPercentValue = false;
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-kpi/new-kpi-item-placeholder/new-kpi-item-placeholder.component.ts